var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.23686L5.36345 5.89349C5.54552 6.0862 5.54552 6.38752 5.36345 6.58023L5 6.23686ZM0.13655 1.81709C-0.0530896 1.61636 -0.0440998 1.29991 0.156628 1.11027C0.357356 0.920632 0.673811 0.929621 0.86345 1.13035L0.13655 1.81709ZM0.86345 11.3434C0.673811 11.5441 0.357357 11.5531 0.156629 11.3635C-0.0440993 11.1738 -0.0530891 10.8574 0.13655 10.6566L0.86345 11.3434ZM4.63655 6.58023L0.13655 1.81709L0.86345 1.13035L5.36345 5.89349L4.63655 6.58023ZM0.13655 10.6566L4.63655 5.89349L5.36345 6.58023L0.86345 11.3434L0.13655 10.6566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.711be7e24a7b959f028bf53bba1c88ff.svg";
export { ForwardRef as ReactComponent };